// The icons a funnel can pick, grouped by theme: work, real estate, sales, people, services,
// highlights. Written out in full so Tailwind generates each class; the backend accepts any
// i-lucide-* name (Pipeline::ICON_FORMAT).
export const PIPELINE_ICONS = [
  'i-lucide-kanban',
  'i-lucide-briefcase',
  'i-lucide-clipboard-list',
  'i-lucide-file-text',
  'i-lucide-file-signature',
  'i-lucide-scroll-text',
  'i-lucide-folder',
  'i-lucide-calendar-check',
  'i-lucide-clock',
  'i-lucide-scale',
  'i-lucide-gavel',
  'i-lucide-house',
  'i-lucide-building-2',
  'i-lucide-building',
  'i-lucide-store',
  'i-lucide-warehouse',
  'i-lucide-key-round',
  'i-lucide-bed-double',
  'i-lucide-sofa',
  'i-lucide-map-pin',
  'i-lucide-landmark',
  'i-lucide-trees',
  'i-lucide-handshake',
  'i-lucide-badge-dollar-sign',
  'i-lucide-banknote',
  'i-lucide-wallet',
  'i-lucide-piggy-bank',
  'i-lucide-coins',
  'i-lucide-hand-coins',
  'i-lucide-receipt',
  'i-lucide-percent',
  'i-lucide-calculator',
  'i-lucide-shopping-cart',
  'i-lucide-trending-up',
  'i-lucide-target',
  'i-lucide-users',
  'i-lucide-user-round',
  'i-lucide-user-plus',
  'i-lucide-contact',
  'i-lucide-headset',
  'i-lucide-message-circle',
  'i-lucide-phone',
  'i-lucide-mail',
  'i-lucide-bell',
  'i-lucide-wrench',
  'i-lucide-hammer',
  'i-lucide-drill',
  'i-lucide-hard-hat',
  'i-lucide-paint-roller',
  'i-lucide-paintbrush',
  'i-lucide-droplet',
  'i-lucide-truck',
  'i-lucide-package',
  'i-lucide-rocket',
  'i-lucide-megaphone',
  'i-lucide-star',
  'i-lucide-heart',
  'i-lucide-sparkles',
  'i-lucide-award',
  'i-lucide-trophy',
  'i-lucide-zap',
  'i-lucide-lightbulb',
  'i-lucide-flag',
  'i-lucide-shield-check',
];

export const DEFAULT_PIPELINE_ICON = 'i-lucide-kanban';
